import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { workspaceApiUrlPrefix } from '@workspace/shared/constants/envConfig';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import _ from 'lodash';
let ShareSettingsApi = class ShareSettingsApi extends PsHttpService {
    async queryGroupMemberInFolder(params) {
        const res = await this.get({
            url: `group/${params.groupId}/collaboration-member`,
            params: _.pick(params, ['share_type', 'share_id', 'page', 'limit', 'name']),
            cache: true,
        });
        return res.data;
    }
    async queryGroupMember(params) {
        const res = await this.get({
            url: `group/${params.groupId}/member`,
            params: {
                page: params.page,
                limit: params.limit,
            },
        });
        return res.data;
    }
    async queryGroup(params) {
        const res = await this.get({
            url: 'group/think',
            params,
        });
        return res.data;
    }
    get options() {
        return {
            baseURL: workspaceApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    async getShareSettings(data) {
        let url = `space/${data.spaceId}/preview`;
        if (data.folderId) {
            url = `space/${data.spaceId}/folder/${data.folderId}/preview`;
        }
        const res = await this.get({
            url,
        });
        return res.data;
    }
    async createShareCode(data) {
        const res = await this.post({
            url: 'share-code',
            data,
        });
        return res.data;
    }
    async switchSharePublic(data) {
        const res = await this.put({
            url: 'free-share/switch',
            data,
        });
        return res.data;
    }
    async getCollaborators(params) {
        let url = `space/${params.space_id}/folder/${params.folder_id}/collaboration-member`;
        if (params.folder_id === '-root') {
            url = `space/${params.space_id}/collaboration-member`;
        }
        const res = await this.get({
            url,
        });
        return res.data;
    }
    async updateCollaborator(data) {
        const res = await this.post({
            url: `${data.spaceId}/multi-share`,
            data: _.omit(data, 'spaceId'),
        });
        return res.data;
    }
    async getCustomRoles() {
        const res = await this.get({
            url: 'custom-role',
        });
        return res.data;
    }
    async createCustomRole(data) {
        const res = await this.post({
            url: 'custom-role',
            data: { name: data.name, permissions: data.permissions },
        });
        return res.data;
    }
    async updateCustomRole(data) {
        const res = await this.put({
            url: `custom-role/${data.roleId}`,
            data: { name: data.name, permissions: data.permissions },
        });
        return res.data;
    }
    async deleteCustomRole(data) {
        const res = await this.delete({
            url: `custom-role/${data.roleId}`,
        });
        return res.data;
    }
};
ShareSettingsApi = __decorate([
    injectable()
], ShareSettingsApi);
export { ShareSettingsApi };
